export default {
    // title 
    titleMarketUpdates: 'बाजार अपडेट',
    titleTrendingCompanies: 'ट्रेंडिंग कंपनियां',
    titleInvite: "आमंत्रित करें और पुरस्कार जीतें",
    titleOnboarding: "ऑनबोर्डिंग किट",


    exportingLeadsToACSV: "CSV में लीड निर्यात करने पर {count} क्रेडिट का उपयोग होगा। | CSV में लीड निर्यात करने पर {count} क्रेडिट का उपयोग होगा।",
    

    // trending companies

    // invite
    forReferrals: "रेफरल के लिए:",
    inviteBtn: 'आमंत्रित करें',
    copyLink: 'लिंक कॉपी करें',
    shareYourReferralLink: 'अपना रेफरल लिंक साझा करें या दूसरों को आमंत्रित करने के लिए एक ईमेल दर्ज करें। उनके जुड़ने पर पुरस्कार अर्जित करें!',
    forTeamInvites: "टीम के आमंत्रण के लिए (क्रेडिट अर्जित करने के लिए):",
    assignTeamInvites: "टीम के आमंत्रण असाइन करें",
    lookingToGrowYourTeam: "अपनी टीम बढ़ाना चाहते हैं? आमंत्रण असाइन करें और हर बार जब कोई जुड़ता है तो क्रेडिट अर्जित करना शुरू करें!",
    addMultipleAddresses: "अल्पविराम से अलग करके कई पते जोड़ें",
    greatProgress: "बढ़िया प्रगति! पूरे {count} क्रेडिट अनलॉक करने के लिए आमंत्रित करते रहें।",
    startInviting: 'आमंत्रित करना शुरू करें और {count} क्रेडिट तक कमाएं!',
    allSet: "सब कुछ तैयार है! आपने अपने {count} क्रेडिट अर्जित कर लिए हैं—आमंत्रित करने के लिए धन्यवाद!",


    // custom insight
    addYourOwnCustomInsights: "अपनी खुद की कस्टम अंतर्दृष्टि जोड़ें",
    companyKeyMilestones: "कंपनी के प्रमुख मील के पत्थर",
    listMajorCompetitors: "समान उद्योग में प्रमुख प्रतिस्पर्धियों की सूची बनाएं",
    analyzeMarketPresence: "कंपनी की बाजार उपस्थिति का विश्लेषण करें",
    poweredByAi: "एआई द्वारा संचालित",

    // onboarding kit
    grantedUponCompletion: '{count} पूरा होने पर दिए गए',
    granted_complete: '{count} क्रेडिट बोनस प्रदान किया गया है!',


    // ai
    meetRonnaAi: "रोनाएआई से मिलें - आपका स्मार्ट व्यवसाय सहायक",
    askAnything: "कुछ भी पूछें...",
    askQuestionsExploreStrategies: 'प्रश्न पूछें, रणनीतियों का पता लगाएं, या आपके लिए तैयार की गई त्वरित अंतर्दृष्टि प्राप्त करें।',
    limitedView: "सीमित दृश्य",
    viewFullCompanyDetails: "कंपनी का पूरा विवरण देखें",
    recentThreads: "हाल के थ्रेड",
    recentlyViewed: "हाल ही में देखे गए",
    companyAndWebsite: "कंपनी / वेबसाइट",
    noResultsAskAi: "कोई परिणाम नहीं? संबंधित जानकारी के लिए रोनाएआई से पूछें",
    allSearchResultsFor: "{count} के लिए सभी खोज परिणाम",
    searchForAnything: "कुछ भी खोजें",
    pressEnter: "एंटर दबाएं",
    askRonnaAI: "रोनाएआई से पूछें:",
    clickToChatWithRonnaAI: "रोनाएआई के साथ चैट करने और अधिक विवरण प्राप्त करने के लिए क्लिक करें",
    useRonnaAIToExploreBusinessDirectories: "व्यापार निर्देशिकाओं, अंतर्दृष्टि, और बहुत कुछ तुरंत जानने के लिए रोनाएआई का उपयोग करें।",
    ronnaAI: 'रोनाएआई',
    findSearchHistory: "खोज इतिहास खोजें",
    Today: 'आज',
    "7 Days": "7 दिन",
    '30 Days': "अधिक",
    deleteRecord: "रिकॉर्ड हटाएं",
    newChat: "नई चैट",
    aiTabAnswer: "उत्तर",
    aiTabCompanies: "कंपनियां",
    aiTabSources: "स्रोत",
    processingYourRequest: "आपके अनुरोध को संसाधित किया जा रहा है...",
    thinkingDeeply: "गहनता से सोच रहा हूँ",
    generatingAPlan: "एक योजना बना रहा हूँ",
    noHistoryYet: "अभी तक कोई इतिहास नहीं है",

    // advertisement
    targetLocation: "लक्ष्य स्थान",
    open_ad: "विज्ञापन खोलें",
    ad_type_label: {
      text: "टेक्स्ट क्रिएटिव",
      image: "इमेज क्रिएटिव",
      video: "वीडियो क्रिएटिव",
      carousel: "कैरोसेल क्रिएटिव",
      other: "क्रिएटिव",
    },
    est_impressions: "अनुमानित इंप्रेशन",
    ads: "विज्ञापन",

    // expansion signals (Phase 1)
    expansion: {
        companyFacts: {
          duplicateProfileNotice: "यह एक डुप्लिकेट प्रोफ़ाइल है।",
          viewCurrentProfile: "वर्तमान प्रोफ़ाइल देखें",
          duplicateProfileTip: "यह प्रोफ़ाइल डुप्लिकेट है — वर्तमान प्रोफ़ाइल खोलें",
        },
        jobsInsights: {
            heading: "हायरिंग गतिविधि",
            windowReadout: "पिछले {n} दिन",
            windowHint: "इस अवधि में सक्रिय भर्तियों की गिनती",
            kpiOpen: "खुली भूमिकाएँ",
            kpiPosted: "पोस्ट की गई भूमिकाएँ",
            openSub: "कुल {n} खुली",
            kpiPace: "हायरिंग गति",
            kpiTopFunction: "प्रमुख फ़ंक्शन",
            kpiMarkets: "बाज़ार",
            newSub: "+{n} नई",
            trendVsPrior: "पिछली अवधि से",
            marketShare: "{pct}% {place}",
            nRoles: "{n} भूमिकाएँ",
            momentumLabel: "हायरिंग गति",
            velAccel: "तेज़ हो रही",
            velSlow: "धीमी हो रही",
            velSteady: "स्थिर",
            mover: "{flag} {place} — पिछले महीने {n} भूमिकाएँ",
            moverSenior: "{flag} {place} — पिछले महीने {n} भूमिकाएँ, ज़्यादातर {tier}",
            moverNew: "· नया बाज़ार",
            exploreLabel: "एक्सप्लोर",
            exploreHint: "किसी बार पर टैप करें — देखें भूमिका, बाज़ार और वरिष्ठता कैसे जुड़े हैं",
            showingOf: "{total} में से {n} भूमिकाएँ",
            clearAll: "साफ़ करें",
            listFilteredBy: "फ़िल्टर:",
            notClassified: "{n} अवर्गीकृत",
            openListTitle: "पोस्ट की गई भूमिकाएँ",
            openListNote: "पोस्ट किया गया · {window}",
            leadTopFunction: "{label} सबसे आगे — {count} भूमिकाएँ",
            leadTopLocation: "{pct}% {place} में",
            tier_executive: "अधिकारी",
            tier_director: "निदेशक",
            tier_manager: "मैनेजर",
            tier_senior: "वरिष्ठ",
            tier_junior: "कनिष्ठ",
            byFunction: "फ़ंक्शन के अनुसार",
            byLocation: "स्थान के अनुसार",
            bySeniority: "वरिष्ठता के अनुसार",
            thisCompany: "यह कंपनी",
            narrFast: "{company} तेज़ी से बढ़ रही है — पिछले {days} दिनों में {n} भूमिकाएँ खुलीं, पिछली अवधि से {pct}% अधिक।",
            narrUp: "{company} सक्रिय रूप से भर्ती कर रही है — पिछले {days} दिनों में {n} नई भूमिकाएँ, पिछली अवधि से {pct}% अधिक।",
            narrSteady: "{company} की भर्ती स्थिर है — पिछले {days} दिनों में {n} भूमिकाएँ, पिछली अवधि के समान।",
            narrDown: "{company} की भर्ती धीमी हुई — पिछले {days} दिनों में {n} भूमिकाएँ, पिछली अवधि से {pct}% कम।",
            narrQuiet: "{company} में {open} खुली भूमिकाएँ हैं, पर हाल में नई गतिविधि कम है।",
            narrMix: "{fn}-प्रधान और {loc} में केंद्रित।",
            narrMixSenior: "{fn}-प्रधान और {loc} में केंद्रित, जिनमें {pct}% नेतृत्व भूमिकाएँ हैं।",
            loadError: "हायरिंग जानकारी लोड नहीं हो सकी",
            retry: "पुनः प्रयास",
            none: "—",
        },
        adsInsights: {
            eyebrow: "विज्ञापन गतिविधि",
            openListTitle: "सक्रिय विज्ञापन",
            lead: "{markets} बाज़ारों में {n} सक्रिय अभियान",
            kpiActive: "सक्रिय अभियान",
            kpiMarkets: "लक्षित बाज़ार",
            kpiTopChannel: "प्रमुख चैनल",
            kpiTopFormat: "मुख्य प्रारूप",
            leadReach: "{reach} तक पहुँच",
            kpiMomentum: "गति",
            windowSub: "पिछले {n} दिन",
            trendVsPrior: "पिछली अवधि से",
            sparkLabel: "अभियान लॉन्च",
            moreInsights: "और जानकारी",
            lessInsights: "जानकारी छिपाएँ",
            byReach: "रीच के अनुसार (इंप्रेशन)",
            reach_lt_1k: "< 1K",
            reach_1k_10k: "1K–10K",
            reach_10k_50k: "10K–50K",
            reach_50k_100k: "50K–100K",
            reach_100k_500k: "100K–500K",
            reach_500k_1m: "500K–1M",
            reach_1m_plus: "1M+",
            reachPeak: "शीर्ष {peak}",
            byMarket: "लक्षित बाज़ार अनुसार",
            byChannel: "चैनल अनुसार",
            byFormat: "प्रारूप अनुसार",
            byPlacement: "प्लेसमेंट के अनुसार",
            exploreLabel: "एक्सप्लोर",
            exploreHint: "बार पर टैप करें — रीच, बाज़ार और चैनल का संबंध देखें",
            exploringOf: "हाल के {total} में से {n} एक्सप्लोर हो रहे",
            showingOf: "{total} विज्ञापनों में से {n}",
            clearAll: "साफ़ करें",
            leadTopMarket: "{pct}% {place} को लक्षित",
            leadTopChannel: "{pct}% {channel} पर",
            noImpression: "इन विज्ञापनों के लिए इंप्रेशन डेटा नहीं",
            noImpressionN: "{n} में इंप्रेशन डेटा नहीं",
            noMarket: "कोई लक्षित बाज़ार डेटा नहीं",
            noMarketN: "{n} में लक्षित बाज़ार नहीं",
            marketLed: "मुख्यतः {place}",
            creatives: "हाल के क्रिएटिव",
            nCampaigns: "{n} अभियान",
            loadError: "विज्ञापन जानकारी लोड नहीं हो सकी",
            retry: "पुनः प्रयास",
            none: "—",
        },
        newsInsights: {
            eyebrow: "मीडिया कवरेज",
            lead: "पिछले {days} दिनों में {n} उल्लेख",
            kpiMentions: "उल्लेख",
            kpiMomentum: "गति",
            kpiPositive: "विस्तार संकेत",
            kpiRisk: "जोखिम संकेत",
            kpiTopics: "विषय",
            kpiSources: "स्रोत",
            ledBy: "मुख्यतः {x}",
            windowSub: "पिछले {n} दिन",
            trendVsPrior: "पिछली अवधि से",
            sparkLabel: "कवरेज मात्रा",
            fundingLatest: "नवीनतम राउंड",
            moreInsights: "और जानकारी",
            lessInsights: "जानकारी छिपाएँ",
            byTopic: "विषय अनुसार",
            byMarket: "बाज़ार अनुसार",
            openListTitle: "हाल की खबरें",
            exploreHint: "सूची फ़िल्टर करने हेतु विषय पर टैप करें",
            loadError: "मीडिया जानकारी लोड नहीं हो सकी",
            retry: "पुनः प्रयास",
            none: "—",
        },
        pitch: {
            headline: "Pubrio · नए देशों में विस्तार कर रही कंपनियों को खोजें।",
            body: "हर दिन हज़ारों कंपनियाँ नए बाज़ारों में प्रवेश करती हैं। पहली कॉल बनें, आख़िरी नहीं।",
            dismiss: "खारिज करें",
        },
        kpi: {
            title: "मुख्य विस्तार मेट्रिक्स",
            mostActiveMarket: "सबसे सक्रिय बाज़ार",
            yourFocus: "आपका फ़ोकस",
            companiesInWindow: "{n} नए सिग्नल के साथ · {window}",
            bestToContact: "अभी संपर्क करने का सबसे अच्छा समय",
            inExpandingStage: "एक्सपैंडिंग चरण में",
            movingUnusuallyFast: "असामान्य रूप से तेज़ी से बढ़ रहा है",
            aheadOfPace: "सामान्य गति से आगे",
            hot: "हॉट",
            newActivity: "नई गतिविधि सिग्नल",
            activeMarkets: "सक्रिय बाज़ार",
            thisWeek: "इस सप्ताह",
            last30Days: "पिछले 30 दिन",
            movementHeadline: "इस अवधि की नई गतिविधि",
            movementHint: "{total} बाज़ारों में से {active} में",
            // Tile 2-4 hint suffixes — GLOBAL mode appends a country chip,
            // SELECTED mode reuses tile 1's focus country and drops the chip.
            hintOfMarket: "बाज़ार का {rate}",
            hintOfFocus: "{country} कंपनियों का {rate}",
            hintAheadOfPaceGlobal: "{rate} सामान्य गति से आगे",
            hintAheadOfPaceFocus: "{country} का {rate} सामान्य गति से आगे",
            hintNewThisWeekGlobal: "{rate} इस सप्ताह नए",
            hintNewThisWeekFocus: "{country} का {rate} इस सप्ताह नए",
            // Empty state for SELECTED mode when the picked country has no data
            // in the active date window.
            noDataInWindow: "इस अवधि में अभी तक कोई सिग्नल नहीं",
        },
        competitive: {
            heading: "प्रतिस्पर्धी विस्तार तुलना",
            subCurated: "{name} के अंतरराष्ट्रीय विस्तार की उसके प्रतिस्पर्धियों से तुलना",
            comparingAgainst: "तुलना किनसे",
            addCompetitor: "प्रतिस्पर्धी जोड़ें",
            addSearching: "खोज रहे हैं…",
            addEmpty: "कोई कंपनी नहीं मिली",
            removeCompetitor: "हटाएँ",
            takeawayLead: "{metric} में {name} {n} प्रतिस्पर्धियों से आगे है।",
            takeawayRank: "{metric} में {name} {total} प्रतिस्पर्धियों में #{rank} पर है।",
            colCompany: "कंपनी",
            colMarket: "बाज़ार",
            colActiveMarkets: "बाज़ार",
            colNewMarkets: "नए बाज़ार",
            colMomentumPct: "गति",
            colSignalCount: "गतिविधि",
            colExpansionScore: "विस्तार स्कोर",
            colWindowExpansionScore: "हाल का स्कोर",
            colIndustry: "उद्योग",
            colCountry: "मुख्यालय",
            colEmployees: "कर्मचारी",
            colFounded: "स्थापना",
            colWebsite: "वेबसाइट",
            colTopMarket: "शीर्ष विस्तार बाज़ार",
            colNewestMarket: "नवीनतम प्रवेश",
            colScaling: "स्केलिंग",
            colPipeline: "पाइपलाइन",
            colMatch: "मिलान",
            columns: "कॉलम",
            columnsHint: "तुलना में फ़ील्ड जोड़ें",
            fieldsGroupExpansion: "विस्तार मेट्रिक्स",
            fieldsGroupCompany: "कंपनी जानकारी",
            you: "आपकी कंपनी",
            openCompany: "कंपनी खोलें",
            pendingHint: "विस्तार डेटा लोड हो रहा है",
            empty: "अभी तक विस्तार डेटा वाला कोई प्रतिस्पर्धी नहीं।",
            cellSignals: "{n} सिग्नल",
            hoverHint: "वास्तविक देश देखने के लिए किसी बाज़ार मेट्रिक पर माउस ले जाएँ।",
            coverageTitle: "बाज़ार कवरेज",
            coverageSub: "हर प्रतिद्वंद्वी कहाँ और कितनी गहराई से — {total} में से {gaps} ऐसे बाज़ार जहाँ वे हैं पर आप नहीं।",
            covAll: "सभी",
            covGaps: "रिक्त",
            covYours: "आपके",
            watch: "बाज़ार पर नज़र रखें",
            fieldCaption: "बार सापेक्ष आकार दिखाते हैं; मिनी-चार्ट प्रत्येक प्रतिद्वंद्वी का साप्ताहिक गतिविधि रुझान है।",
            legendStage: "रंग = चरण",
            legendRecent: "हाल ही में सक्रिय",
            covYouHint: "छायांकित = आप",
            coverageCount: "{total} में से {n} मौजूद",
            cellTypes: "सिग्नल प्रकार",
            cellSince: "पहली बार देखा गया",
            cellActive: "{t} सक्रिय",
            sortLabel: "बाज़ार क्रमबद्ध करें",
            covSortCoverage: "कवरेज",
            covSortRecent: "हाल का",
            searchMarket: "बाज़ार खोजें…",
            noMarkets: "आपके फ़िल्टर से कोई बाज़ार मेल नहीं खाता।",
        },
        verdict: {
            newMarkets: "नए बाज़ार",
            momentum: "गति",
            expansionScore: "विस्तार स्कोर",
            vsPrior: "पिछली अवधि की तुलना में",
            noneThisPeriod: "इस अवधि में कोई नहीं",
            signalsLabel: "सिग्नल",
            scoreVeryStrong: "बहुत मज़बूत",
            scoreStrong: "मज़बूत",
            scoreDeveloping: "विकसित हो रहा",
            scoreEarly: "प्रारंभिक चरण",
        },
        summary: {
            heading: "वैश्विक विस्तार",
            subheading: "यह कंपनी कहाँ काम करती है और किन बाज़ारों में आगे बढ़ रही है।",
            subheadingCount: "दुनिया भर के {n} बाज़ारों में — कहाँ से शुरू हुई, और अभी कहाँ बढ़ रही है।",
            founded: "स्थापना",
            employees: "कर्मचारी",
            markets: "बाज़ार",
            marketsHintFrom: "{hq} से विस्तार",
            marketsHintWorldwide: "विश्वव्यापी उपस्थिति",
            furthestStage: "सबसे आगे का चरण",
            movingNow: "अभी आगे बढ़ रहे",
            movingNowHint: "पिछले 90 दिनों में आगे बढ़े",
            upToMarkets: "{n} बाज़ारों तक",
            stages: "चरण",
            loading: "विस्तार लोड हो रहा है…",
            empty: "इस कंपनी के लिए अभी तक कोई विस्तार सिग्नल ट्रैक नहीं किया गया।",
            // Enriched no-data / load-error states (the map + feed surface).
            emptyTitle: "विस्तार सिग्नल सुने जा रहे हैं",
            emptyDetail: "अभी दिखाने के लिए कुछ नहीं है। जैसे-जैसे {company} नए बाज़ारों में भर्ती करेगी, समाचार बनाएगी और विज्ञापन चलाएगी, सिग्नल यहाँ दिखाई देंगे।",
            thisCompany: "यह कंपनी",
            established: "स्थापित",
            establishedTip: "इन बाज़ारों में सक्रिय — कोई नई विस्तार गतिविधि नहीं",
            establishedNote: "{company} {n} बाज़ारों में स्थापित है — इस अवधि में कोई नई विस्तार गतिविधि नहीं।",
            errorTitle: "सिग्नल सेवा तक नहीं पहुँच सके",
            errorDetail: "हम अभी विस्तार डेटा लोड नहीं कर सके। यह आमतौर पर अस्थायी होता है — एक बार फिर प्रयास करें।",
            retry: "पुनः प्रयास करें",
            // Command-bar button hover tooltips — every control gets a consistent hint.
            tipMarket: "बाज़ार के अनुसार फ़िल्टर करें",
            tipDate: "समय सीमा बदलें",
            tipStage: "जीवनचक्र चरण के अनुसार फ़िल्टर करें",
            tipExport: "इस कंपनी को एक्सपोर्ट करें",
            tipClear: "सभी फ़िल्टर साफ़ करें",
            // Insight line under the "Global expansion" heading.
            insight: "{total} बाज़ारों में · पहली बार {year} में {market} में आए · {moving} पिछले 90 दिनों में आगे बढ़े",
            insightNoFirst: "{total} बाज़ारों में · {moving} पिछले 90 दिनों में आगे बढ़े",
            // Time-scope segmented control.
            timeAll: "सभी समय",
            time12m: "12माह",
            time6m: "6माह",
            time3m: "3माह",
            // Market-focus filter — narrows the map + entry timeline to chosen markets.
            filterFocus: "बाज़ारों पर ध्यान दें",
            filterAll: "सभी बाज़ार",
            filterMore: "+{n} और",
            filterClear: "साफ़ करें",
            filterShowing: "{total} में से {n} बाज़ार",
        },
        // Activity pulse — "what they're doing now" across all markets (ActivityPulse.vue).
        pulse: {
            heading: "गतिविधि पल्स",
            windowHint: "विंडो ऊपर दिए गए दिनांक फ़िल्टर का अनुसरण करती है",
            catHiring: "भर्ती",
            catMarketing: "मार्केटिंग और पीआर",
            catProduct: "उत्पाद और तकनीक",
            catFootprint: "उपस्थिति",
            catPartners: "साझेदारियाँ",
            leadMore: "{type} +{n}",
            leadNone: "कोई गतिविधि नहीं",
            trendNew: "नई",
            trendSteady: "स्थिर",
            trendEnded: "समाप्त",
            recentEvents: "हाल की घटनाएँ",
            headcountReduction: "कर्मचारियों में कटौती",
            postingCount: "इस शीर्षक के साथ {n} पद",
            loadMore: "और लोड करें",
            loadingMore: "लोड हो रहा है…",
            viewSource: "स्रोत देखें",
            via: "{source} के माध्यम से",
            sourceNews: "समाचार",
            sourceJobs: "नौकरी",
            sourceAds: "विज्ञापन",
            focusMarket: "फ़ीड में {market} पर ध्यान दें",
            drillSub: "{n} सिग्नल · {types} प्रकार सक्रिय",
            hQuiet: "सभी बाज़ारों में शांत — इस विंडो में कोई सिग्नल नहीं।",
            hNew: "नई {category} गतिविधि — {n} ताज़ा सिग्नल अभी दिखाई दिए।",
            hRising: "{category} तेज़ हो रहा है — पिछली अवधि की तुलना में {pct}% ऊपर।",
            hTop: "{category} में सबसे अधिक सक्रिय — {type} ({n} सिग्नल) के नेतृत्व में।",
            hTopPlain: "{category} में सबसे अधिक सक्रिय — {n} सिग्नल।",
        },
        // Stage-distribution bar on the company-detail page (ExpansionPortfolioBar.vue).
        portfolio: {
            heading: "विस्तार पोर्टफोलियो",
            markets: "बाज़ार",
        },
        // Per-market journey list on the company-detail page (MarketTimeline.vue).
        timeline: {
            heading: "बाज़ार प्रवेश टाइमलाइन",
            subEntry: "इस कंपनी ने हर बाज़ार में किस क्रम में प्रवेश किया — सबसे पुराने से नवीनतम तक",
            subMomentum: "सबसे हाल की चरण गति के अनुसार क्रमबद्ध बाज़ार",
            byEntry: "प्रवेश के अनुसार",
            byMomentum: "गति के अनुसार",
            signals: "सिग्नल",
            signalTypes: "सिग्नल प्रकार",
            stageUp: "चरण उन्नयन · {when}",
            stageUpToday: "चरण उन्नयन · आज",
            now: "अभी",
            firstSignal: "पहला सिग्नल पता चला",
            longEstablished: "लंबे समय से स्थापित",
            ordinalEntered: "{ord} बाज़ार में प्रवेश किया",
            trackedDays: "{n} दिन ट्रैक किए",
            trackedMonths: "{n} माह ट्रैक किए",
            trackedYears: "{n} वर्ष ट्रैक किए",
            confidence: "{n}% विश्वास",
            empty: "इस फ़िल्टर से कोई बाज़ार मेल नहीं खाता।",
            showAll: "सभी {n} दिखाएं",
            showLess: "कम दिखाएं",
        },
        // Per-market signal feed on the company-detail page (SignalFeed.vue).
        feed: {
            signalsIn: "इसमें सिग्नल",
            signals: "सिग्नल",
            via: "{source} के माध्यम से",
            reached: "{stage} तक पहुँचा",
            firstSignal: "पहला सिग्नल",
            show: "{n} दिखाएं",
            hide: "छिपाएं",
            empty: "इस बाज़ार में अभी तक कोई सिग्नल नहीं मिला।",
            emptyHint: "मानचित्र पर कोई अन्य बाज़ार चुनें, या अधिक गतिविधि दिखाने के लिए समय सीमा बढ़ाएं।",
            // No market chosen yet — invite a pick (vs. filters that cleared every market).
            pickTitle: "एक बाज़ार चुनें",
            pickHint: "इसके सिग्नल देखने के लिए टाइमलाइन पर कोई भी बाज़ार चुनें।",
            noMarketsTitle: "दृश्य में कोई बाज़ार नहीं",
            noMarketsHint: "बाज़ारों को वापस लाने के लिए अपने फ़िल्टर समायोजित करें।",
            loadMore: "और सिग्नल लोड करें",
        },
        // Markets "first / now" rail on the company-detail page (JourneyRail.vue).
        journey: {
            wentFirst: "पहले प्रवेश किया",
            wentFirstSub: "जिस क्रम में उन्होंने विस्तार किया",
            movingNow: "अभी आगे बढ़ रहे",
            movingNowSub: "सबसे हाल की चरण गति",
            none: "अभी तक कोई विस्तार बाज़ार नहीं",
            showAll: "सभी {n} दिखाएं",
            showLess: "कम दिखाएं",
        },
        dateRange: {
            today: "आज",
            last7: "पिछले 7 दिन",
            last30: "पिछले 30 दिन",
            last90: "पिछले 90 दिन",
            last12m: "पिछले 12 महीने",
            customLabel: "कस्टम रेंज",
            startPlaceholder: "शुरू",
            endPlaceholder: "समाप्त",
        },
        countryChips: {
            title: "बाज़ार",
            subtitle: "डैशबोर्ड को स्कोप करने के लिए एक देश चुनें",
            ariaLabel: "फ़ॉलो किए गए बाज़ार",
            addMarket: "बाज़ार जोड़ें",
            compare: "तुलना करें",
            more: "और",
            remove: "बाज़ार हटाएं",
            comparingNMarkets: "{n} बाज़ार की तुलना | {n} बाज़ारों की तुलना",
            pickMarketsToCompare: "तुलना के लिए बाज़ार क्लिक करें",
            multiSelectOff: "बहु-चयन",
            multiSelectOnN: "बहु-चयन · {n}",
        },
        mapMode: {
            toggleAriaLabel: "मानचित्र दृश्य मोड",
            global: "सभी बाज़ार",
            intoCountry: "इनबाउंड",
            outgoing: "आउटगोइंग",
            outgoingHint: "चयनित देश से विस्तार कर रही कंपनियाँ दिखाएं",
            outgoingDisabledHint: "आउटगोइंग विस्तार देखने के लिए पहले एक देश चुनें",
            backToOverview: "अवलोकन पर वापस जाएं",
            // TODO: translate (placeholders copied from en.js)
            intoCountryHint: "Companies expanding INTO the selected country",
            intoCountryDisabledHint: "Pick a country first to see inbound flow",
        },
        find: {
            heading: "आप क्या खोज रहे हैं?",
            placeholderHero: "एक बाज़ार का वर्णन करें — जैसे जर्मनी में विस्तार करने वाली AI कंपनियाँ",
            placeholderDocked: "एक बाज़ार का वर्णन करें",
            submit: "खोजें",
            clear: "साफ़ करें",
            hintPrefix: "आज़माएँ:",
            examples: [
                "अमेरिका में विस्तार करने वाली फिनटेक कंपनियाँ",
                "जर्मनी में आक्रामक रूप से विस्तार करने वाली AI कंपनियाँ",
                "यूके में प्रवेश करने वाली कंपनियाँ",
                "जापान में विस्तार करने वाली AI कंपनियाँ",
                "फ्रांस में विस्तार करने वाली जर्मन कंपनियाँ",
                "सिंगापुर में प्रवेश करने वाली कंपनियाँ",
            ],
            noMatch: "इसे फ़िल्टर में नहीं बदला जा सका। कोई बाज़ार, चरण या क्षेत्र बताकर देखें।",
        },
        compare: {
            title: "बाज़ारों की तुलना करें",
            pickMarket: "एक बाज़ार चुनें",
            emptyHint: "तुलना के लिए एक बाज़ार जोड़ें",
            totalCompanies: "ट्रैक की गई कंपनियाँ",
            readyToContact: "संपर्क के लिए तैयार (एक्सपैंडिंग)",
            newThisMonth: "इस महीने के नए ट्रांज़िशन",
            aheadOfPace: "सामान्य गति से आगे (30 दिन)",
            stageBreakdown: "चरण विवरण",
            expandingShareLabel: "तैयार",
            viewMarket: "यह बाज़ार देखें",
            viewMarketAction: "देखें",
            addColumn: "बाज़ार जोड़ें",
            removeColumn: "यह बाज़ार हटाएं",
            metricHeader: "मेट्रिक",
            deltaHeader: "Δ",
            winnerBadgeTitle: "चयनित बाज़ारों में सर्वोच्च",
            lensLabel: "तुलना का आधार",
            lensVolume: "कुल",
            lensShare: "हिस्सा %",
            lensShareHint: "हर मेट्रिक उस बाज़ार की ट्रैक की गई कंपनियों के % के रूप में",
            insightTitle: "यह आपको क्या बताता है",
            insightOverall: "{winner} कुल {total} में से {n} मेट्रिक्स पर आगे है।",
            insightExpanding: "{winner} के पास अभी {loser} की तुलना में {n} अधिक संपर्क-के-लिए-तैयार कंपनियाँ हैं।",
            insightMomentumMultiple: "{winner} इस महीने {loser} की तुलना में {multiple}× तेज़ी से नई कंपनियाँ जोड़ रहा है।",
            insightMomentumAbsolute: "{winner} ने इस महीने {n} नई कंपनियाँ जोड़ीं — {loser} ने कोई नहीं जोड़ी।",
            insightPace: "{market} में {n} कंपनियाँ सामान्य से तेज़ी से बढ़ रही हैं — करीब से देखने योग्य।",
            insightAboveWeight: "{winner} अपने आकार से बढ़कर प्रदर्शन कर रहा है — इसके बाज़ार का {winnerPct} संपर्क के लिए तैयार है, जबकि {larger} में यह {largerPct} है।",
            dimExpanding: "संपर्क-के-लिए-तैयार",
            dimNewThisMonth: "इस महीने नए",
            dimAheadOfPace: "गति से आगे",
            dimTotal: "कुल ट्रैक किए गए",
            dimTotalShare: "चयनित का हिस्सा",
            drillCellTitle: "{country} खोलें",
            drillCellTitleStage: "{country} खोलें — {stage} चरण",
            drillSegTitle: "{country} खोलें — {stage} ({n} कंपनियाँ)",
            viewCrossMarket: "{n} बाज़ारों में खोजें",
            summaryWinner: "{winner} के पास {loser} की तुलना में {n} अधिक संपर्क-के-लिए-तैयार कंपनियाँ हैं।",
            summaryTie: "दोनों बाज़ारों में संपर्क-के-लिए-तैयार कंपनियों की संख्या समान है।",
        },
        countryPicker: {
            title: "एक बाज़ार जोड़ें",
            searchPlaceholder: "देश का नाम या कोड खोजें…",
            noMatch: "आपकी खोज से मेल खाने वाला कोई देश नहीं।",
        },
        stageTiles: {
            title: "चरण वितरण",
            subtitle: "नीचे की सूची को फ़िल्टर करने के लिए एक चरण पर क्लिक करें",
            ariaLabel: "विस्तार चरण",
            bestToReachOut: "संपर्क करने का सबसे अच्छा समय",
            signalsHeading: "हम क्या देखते हैं",
            signalSoon: "जल्द",
            infoAria: "यह चरण कैसे तय होता है",
        },
        stage: {
            exploring: "एक्सप्लोरिंग",
            exploringDescription: "बस देख रहे हैं",
            committing: "कमिटिंग",
            committingDescription: "वास्तविक संसाधन लगा रहे हैं",
            expanding: "एक्सपैंडिंग",
            expandingDescription: "स्थानीय आधार बढ़ा रहे हैं",
            scaling: "स्केलिंग",
            scalingDescription: "स्थानीय मौजूदगी बढ़ा रहे हैं",
        },
        signal: {
            ad: "जियो-टार्गेटेड विज्ञापन",
            event: "सम्मेलन उपस्थिति",
            news: "समाचार / पीआर",
            dns: "डोमेन / एसएसएल",
            tech: "उत्पाद स्थानीयकरण",
            infra: "क्लाउड / इंफ्रास्ट्रक्चर",
            ip: "ट्रेडमार्क / पेटेंट",
            partner: "साझेदारी",
            eventPlus: "प्रदर्शन / वक्तव्य",
            reg: "नियामक लाइसेंस",
            entity: "इकाई पंजीकरण",
            exec: "कार्यकारी नियुक्ति",
            office: "कार्यालय पट्टा",
            hire: "स्थानीय टीम भर्ती",
            scale: "हेडकाउंट स्केलिंग",
            product: "उत्पाद लॉन्च",
        },
        signalTier: {
            premier: "प्रीमियर",
        },
        direction: {
            advancing: "आगे बढ़ रहा है",
            steady: "स्थिर",
            retreating: "पीछे हट रहा है",
            new: "नया",
        },
        freshness: {
            fresh: "ताज़ा",
            cooling: "ठंडा हो रहा है",
            stale: "बासी",
            cold: "ठंडा",
        },
        filters: {
            title: "फ़िल्टर",
            clearAll: "सभी साफ़ करें",
            direction: "दिशा",
            freshness: "ताज़गी",
            employees: "कर्मचारी",
            industry: "उद्योग",
            risk: "जोखिम",
            stage: "चरण",
            scope: "स्कोप",
            founded: "स्थापना",
            signalStrength: "सिग्नल की मज़बूती",
            signalVolume: "सिग्नल संख्या",
            momentum: "गति",
            momentumAccelerating: "तेज़ हो रहा",
            momentumAdvancing: "आगे बढ़ रहा",
            momentumSteady: "स्थिर",
            momentumPullingBack: "पीछे हट रहा",
            signalVolumeAny: "कोई भी",
            signalVolumeWord: "सिग्नल",
            onlyAtRisk: "केवल जोखिम वाले बाज़ार",
            any: "कोई भी",
            employeesCustomRange: "कस्टम रेंज",
            predefinedRange: "पूर्व-निर्धारित रेंज",
            employeesPlaceholder: "आकार सीमा चुनें",
            industrySubCategory: "उप-उद्योग",
            industryCategory: "उद्योग श्रेणियाँ",
            industrySubCategoryPlaceholder: "उप-उद्योग दर्ज करें",
            industryCategoryPlaceholder: "उद्योग श्रेणियाँ दर्ज करें",
            foundedRange: "स्थापना वर्ष",
            foundedFrom: "से",
            foundedTo: "तक",
            min: "न्यूनतम",
            max: "अधिकतम",
            // TODO: translate (placeholders copied from en.js)
            signalType: "Signal type",
            pace: "Pace",
            onlyAheadOfPace: "Only ahead of pace",
            paceHint: "Companies whose elapsed first-signal → latest transition sits in the country's fastest quartile.",
            searchPlaceholder: "Search filters…",
            presets: "Filter presets",
            presetsSavedCount: "{n} saved",
            activeOne: "{n} Active filter",
            activeMany: "{n} Active filters",
            save: "Save",
            clearShort: "Clear",
            groupScope: "Scope",
            groupSignal: "Expansion signal",
            groupSources: "स्रोत",
            groupCompany: "Company profile",
            date: "Date",
            markets: "Markets",
            flowDirection: "Flow direction",
            marketsPlaceholder: "Type a country to scope the dashboard",
            noMatchingFilters: "No filters match",
            addFilter: "Add filter",
            groupRecent: "Recent",
            groupSuggested: "Suggested",
            savedViews: "Saved filters",
            savedViewsCount: "{n} saved",
            noSavedViews: "No saved filters yet.",
            saveCurrentView: "Save current filter",
            deleteView: "Delete filter",
            deleteConfirm: "Delete",
            cancel: "Cancel",
            confirmDeleteView: "Delete the saved filter “{name}”?",
            saveDialogTitle: "Save filter",
            namePrompt: "Name this filter so you can recall it later.",
            namePlaceholder: "e.g. Hot EU SaaS",
            nameRequired: "Give the filter a name.",
            location: "Location",
            locationPlaceholder: "Search country…",
            locationHint: "Filter to companies headquartered in the selected country.",
            revenue: "Revenue",
            revenueRange: "Annual revenue (USD)",
            revenueMin: "Min ($)",
            revenueMax: "Max ($)",
            revenueHint: "Estimated annual revenue range from enrichment data.",
            specialties: "Specialties",
            specialtiesPlaceholder: "Search a specialty…",
            technologies: "Technologies",
            technologiesPlaceholder: "Search a technology…",
            companies: "Companies",
            companiesPlaceholder: "Search a company…",
            activeTitle: "Active",
            activeEmpty: "No filters active",
            dateChipPrefix: "Date",
            marketChipPrefix: "Market",
            savedListChip: "Saved list",
            savedListFilterNote: "Showing one row per company at their highest reached stage. Stage tiles match the list count.",
            originChipPrefix: "From",
            targetChipPrefix: "Into",
            removeFilter: "Remove {label}",
        },
        scope: {
            enteringNewMarket: "नए बाज़ार में प्रवेश",
            expandingWithinPresence: "मौजूदा उपस्थिति में विस्तार",
            establishedOnly: "केवल स्थापित",
        },
        signalStrength: {
            high: "उच्च विश्वास",
            medium: "मध्यम",
            low: "निम्न",
        },
        row: {
            employees: "कर्मचारी",
            marketsCount: "{n} बाज़ार",
            marketsActiveIn: "सक्रिय: {list}",
            founded: "स्थापना",
            journey: "यात्रा",
            journeyLabel: "यात्रा",
            contractionFlag: "{days} दिनों में कोई नए सिग्नल नहीं। यह कंपनी विस्तार रोक रही है या बाहर निकल रही है।",
            noSignalsInDays: "{days} दिनों में कोई नए सिग्नल नहीं। यह कंपनी विस्तार रोक रही है या बाहर निकल रही है।",
            movingFast: "तेज़ी से बढ़ रहा है",
            movingFastDetail: "{months} महीनों में {stages}।",
            addToSequence: "सीक्वेंस में जोड़ें",
            saveToList: "सूची में सहेजें",
            viewProfile: "प्रोफ़ाइल देखें",
            viewSignalsHint: "सभी सिग्नल देखने के लिए क्लिक करें",
            signalCount: "{n} सिग्नल",
            distinctTypes: "{n} सिग्नल प्रकार",
            stageUpInDays: "चरण उन्नयन · {days} दिन पहले",
            stageUpToday: "चरण उन्नयन · आज",
            newInDays: "नया · {days} दिन",
            newToday: "नया · आज",
            selectRow: "कंपनी चुनें",
            lastSignal: "अंतिम सिग्नल",
            // TODO: translate (placeholders copied from en.js)
            contractionFlag_leading: "Early signs of contraction — multiple leading indicators (exec departures, layoff chatter) in the last 60 days.",
            contractionFlag_confirming: "Recent contraction signal — a layoff or downsizing was reported in the last 180 days.",
            contractionFlag_lagging: "Confirmed retreat — a market exit, office closure or de-registration in the last 12 months.",
            contractionFlag_leading_mixed: "Mixed signals — early contraction indicators alongside ongoing expansion activity. Watch closely.",
            contractionFlag_confirming_mixed: "Mixed signals — a recent contraction signal sits alongside fresh expansion activity. Confidence is split; review before acting.",
            stageOf: "Stage {n} of {total}",
            tooltipDirection_advancing: "Moved up at least one stage in the last 30 days",
            tooltipDirection_steady: "No stage change in the last 30 days",
            tooltipDirection_retreating: "Fewer recent signals — this company may be pulling back from this market",
            tooltipDirection_new: "Just appeared as a potential expander",
            tooltipFreshness_fresh: "Last signal in the past 30 days",
            tooltipFreshness_cooling: "Last signal 30 to 60 days ago",
            tooltipFreshness_stale: "Last signal 60 to 90 days ago — activity has cooled",
            tooltipFreshness_cold: "No signals in the past 90 days",
            tooltipSignalCount: "Total expansion signals tracked for this company ({n})",
            tooltipDistinctTypes: "{n} different kinds of signal (hiring, news, office lease, etc.)",
            tooltipStageUp: "Recently moved up to the {stage} stage",
            tooltipNew: "First signal detected recently",
            tooltipSignalType: "Signal type: {type}",
        },
        list: {
            title: "{count} कंपनियाँ",
            titleAll: "{country} में {count} कंपनियाँ",
            titleAllGlobal: "सभी बाज़ारों में {count} कंपनियाँ",
            titleStageScoped: "{stage} में {count} कंपनियाँ — {country}",
            titleStageScopedGlobal: "{stage} में {count} कंपनियाँ — सभी बाज़ार",
            filteredBy: "फ़िल्टर किया गया",
            export: "एक्सपोर्ट",
            previous: "पिछला",
            next: "अगला",
            pageOf: "पेज {page} / {total}",
            selectAll: "सभी चुनें",
            selectAllOption: "सभी",
            selectThisPage: "यह पेज",
            selectCustomize: "कस्टमाइज़ करें",
            selectHint: "इस दृश्य में {count} तक कंपनियाँ चुनें।",
            applySelection: "लागू करें",
            selected: "{n} चयनित",
            bulkSequence: "सीक्वेंस में जोड़ें",
            bulkSave: "सूची में सहेजें",
            bulkExport: "चयनित को एक्सपोर्ट करें",
            findPeople: "लोग खोजें",
            clearSelection: "साफ़ करें",
            paceHint: "{country} में एक्सप्लोरिंग → एक्सपैंडिंग की माध्यिका 6 महीने है। {n} कंपनियाँ गति से आगे हैं।",
            movingFast: "तेज़ी से बढ़ रहा है",
            movingFastDetail: "4 महीनों में एक्सप्लोरिंग → स्केलिंग। {country} में SaaS के लिए माध्यिका 6 महीने है।",
            emptyTitle: "अभी तक कोई कंपनी इस दृश्य से मेल नहीं खाती।",
            emptyBody: "कोई दूसरा बाज़ार आज़माएं या नए सिग्नल आने का इंतज़ार करें।",
            emptyStageTitle: "इस चरण में अभी कोई नहीं।",
            emptyStageBody: "एक्सप्लोर करते रहने के लिए दूसरा चरण चुनें।",
            pickCountryTitle: "शुरू करने के लिए एक देश चुनें।",
            pickCountryBody: "डैशबोर्ड को स्कोप करने के लिए ऊपर एक बाज़ार चिप पर क्लिक करें (या मानचित्र का उपयोग करें)।",
        },
        map: {
            topSectors: "प्रमुख क्षेत्र",
            expandingInto: "गंतव्य",
            comingFrom: "स्रोत",
            tabWhatsNew: "नया क्या है",
            whatsNewAriaLabel: "बाज़ार गतिविधि अंतर्दृष्टि",
            whatsNewCaptionCountry: "{country} में गतिविधियाँ · {window}",
            whatsNewCaptionGlobal: "सभी बाज़ारों में गतिविधियाँ · {window}",
            whatsNewCaptionMulti: "{n} बाज़ारों में गतिविधियाँ · {window}",
            whatsNewCorridorHint: "सूची को {from} → {to} पर फ़िल्टर करें",
            whatsNewDeltaFlat: "स्थिर",
            whatsNewDeltaNew: "नया",
            whatsNewDestinationHint: "{country} पर डैशबोर्ड केंद्रित करें",
            whatsNewEmpty: "चयनित अवधि में कोई बदलाव नहीं। मानचित्र नियंत्रणों से व्यापक तिथि सीमा आज़माएँ।",
            whatsNewFastEmptyBody: "गति से आगे बढ़ रही कंपनियाँ देखने के लिए तिथि सीमा बढ़ाएँ या देश फ़िल्टर हटाएँ।",
            whatsNewFastEmptyTitle: "इस दृश्य में कोई तेज़ गति वाली कंपनी नहीं",
            whatsNewFastExplainer: "अपने बाज़ार में 75% समकक्षों से तेज़ बढ़ रही कंपनियाँ।",
            whatsNewFastMoversTitle: "गति से आगे",
            whatsNewForYouEmptyBody: "इस अवधि में आपकी सहेजी गई किसी कंपनी में चरण बदलाव नहीं हुआ। तिथि सीमा बढ़ाएँ या बाद में देखें।",
            whatsNewForYouEmptyTitle: "आपकी सूचियों में कोई नई हलचल नहीं",
            whatsNewForYouExplainer: "आपकी सहेजी गई कंपनी सूचियाँ जिनके सदस्य इस अवधि में आगे बढ़े।",
            whatsNewFoundedYear: "{year} में स्थापित",
            whatsNewHotCorridors: "सक्रिय गलियारे",
            whatsNewListCount: "{n} कंपनियाँ",
            whatsNewListUpdated: "{time} को अपडेट किया गया",
            whatsNewLoading: "आँकड़े तैयार हो रहे हैं…",
            whatsNewMarketsCount: "{n} नए बाज़ार",
            whatsNewMarketsInlineMore: "+{n} और",
            whatsNewMovesLabel: "इस अवधि में हलचल",
            whatsNewMovingFastDetail: "{from} → {to}, {months} महीने में",
            whatsNewNotableMovers: "उल्लेखनीय हलचल",
            whatsNewOpenList: "सूची खोलें: {name}",
            whatsNewOriginHint: "{country} की कंपनियों पर फ़िल्टर करें",
            whatsNewPipelineMix: "चरण वितरण",
            whatsNewPrevDay: "कल",
            whatsNewPrevDays: "पिछले {n} दिन",
            whatsNewPrevMonth: "पिछला महीना",
            whatsNewPrevWeek: "पिछला सप्ताह",
            whatsNewSavedListMovers: "{count} में नई हलचल",
            whatsNewSavedListMoversAriaLabel: "इस सूची में {count} कंपनियों में नई हलचल",
            whatsNewSavedListTotal: "कुल {total}",
            whatsNewScopeGlobal: "सभी बाज़ार",
            whatsNewScopeMulti: "{n} बाज़ार",
            whatsNewStageHint: "{stage} चरण पर फ़िल्टर करें",
            whatsNewStageUpAt: "चरण वृद्धि · {time}",
            whatsNewStageVelocity: "चरण गति",
            whatsNewStoryCool: "{from} → {to} {delta}% धीमा हुआ",
            whatsNewStoryDeltaDetail: "इस अवधि {current} बनाम पिछली अवधि {previous}",
            whatsNewStoryMover: "{company} अभी {stage} तक पहुँचा",
            whatsNewStoryNew: "{from} → {to} गलियारा इस अवधि में नया है",
            whatsNewStoryNewDetail: "{n} कंपनियों ने अभी कदम बढ़ाया — पहली बार ट्रैक किया गया",
            whatsNewStoryStageDetail: "{n} कंपनियाँ अभी {stage} तक पहुँचीं",
            whatsNewStoryStageDown: "{stage} चरण परिवर्तन {delta}% घटे",
            whatsNewStoryStageUp: "{stage} चरण परिवर्तन {delta}% बढ़े",
            whatsNewStorySurge: "{from} → {to} {delta}% बढ़ा",
            whatsNewSurgingDestinations: "तेज़ी से बढ़ते गंतव्य",
            whatsNewSurgingOrigins: "तेज़ी से बढ़ते स्रोत",
            whatsNewTabFastMovers: "तेज़ गति",
            whatsNewTabForYou: "आपके लिए",
            whatsNewTabWideExpanders: "व्यापक विस्तार",
            whatsNewUnnamedList: "अनाम सूची",
            whatsNewVelocityDetail: "पिछले {window} में {previous} से अधिक",
            whatsNewVelocityDetailNoPrior: "सार्थक गतिविधि वाली पहली अवधि",
            whatsNewVelocityTitle: "इस अवधि {n} कंपनियाँ {verb}",
            whatsNewVerbAcross: "ट्रैक की गई सीमा-पार हलचल",
            whatsNewVerbInto: "{scope} में विस्तार",
            whatsNewViewAll: "सूची की सभी कंपनियाँ देखें",
            whatsNewViewAllN: "सभी {n} कंपनियाँ देखें",
            whatsNewViewList: "पूरी कंपनी सूची देखें",
            whatsNewMarketsChip: "{n}+ बाज़ारों में प्रवेश",
            whatsNewVsPrev: "{label} {n} की तुलना में",
            whatsNewWhereFrom: "मुख्य स्रोत",
            whatsNewWideEmptyBody: "एक साथ कई बाज़ारों में प्रवेश करती कंपनियाँ देखने के लिए तिथि सीमा बढ़ाएँ या देश फ़िल्टर हटाएँ।",
            whatsNewWideEmptyTitle: "इस दृश्य में कोई व्यापक विस्तारक नहीं",
            whatsNewWideExplainer: "वे कंपनियाँ जिन्होंने अभी 3+ नए बाज़ारों में प्रवेश किया — आक्रामक बहु-देश विस्तार।",
            whatsNewWindowDays: "पिछले {n} दिन",
            whatsNewWindowMonth: "पिछले 30 दिन",
            whatsNewWindowToday: "आज",
            whatsNewWindowWeek: "पिछले 7 दिन",
            placeholderAriaLabel: "विस्तार विश्व मानचित्र",
            loadingBasemap: "बेसमैप लोड हो रहा है…",
            loadingCountry: "बाज़ार डेटा लोड हो रहा है…",
            loadingDashboard: "विस्तार डेटा लोड हो रहा है…",
            newThisMonthIn: "{country} में इस महीने नए",
            newTransitionsAllMarkets: "इस महीने के नए ट्रांज़िशन",
            readyToContact: "संपर्क के लिए तैयार",
            tracked: "कुल ट्रैक किए गए",
            activeMarkets: "सक्रिय बाज़ार",
            ctaReadyToContact: "{n} संपर्क-के-लिए-तैयार देखें",
            origins: {
                title: "शीर्ष मूल → {country}",
                total: "{n} सीमा-पार",
                domestic: "+{n} घरेलू ({country} → {country})",
                untracked: "+{n} मूल अभी तक ट्रैक नहीं किए गए",
                empty: "इस बाज़ार के लिए अभी तक कोई मूल डेटा उपलब्ध नहीं।",
                plusMore: "+{n} अधिक मूल",
                clearFilter: "मूल फ़िल्टर साफ़ करें",
            },
            timeFilterLabel: "सिग्नल दिखाएं",
            timeFilterToday: "आज",
            timeFilterWeek: "इस सप्ताह",
            timeFilterMonth: "इस महीने",
            timeFilterAll: "सभी समय",
            activityFeedTitle: "नया क्या है",
            activityFeedEmpty: "चयनित अवधि में कोई नई गतिविधि नहीं।",
            activityFeedFooter: "सभी गतिविधि देखें →",
            activityFeedAdvanced: "{stage} में पहुँचा",
            activityFeedNew: "नए सिग्नल का पता चला",
            activityFeedFrom: "{country} से",
            activityFeedTitleHint: "कंपनी विवरण के लिए क्लिक करें",
            activityFeedTitleHintCountry: "इस बाज़ार पर ध्यान केंद्रित करने के लिए क्लिक करें",
            marketIntelTitle: "बाज़ार खुफिया",
            tabOrigins: "शीर्ष मूल",
            tabActivity: "अभी-अभी आगे बढ़े",
            showActivity: "बाज़ार खुफिया दिखाएं",
            hideActivity: "बाज़ार खुफिया छिपाएं",
            windowEmptyBody: "इस कंपनी की गतिविधि देखने के लिए दिनांक सीमा बढ़ाएँ।",
      noActivityTitle: "इस दृश्य में अभी तक कोई हलचल नहीं।",
            noActivityBody: "कोई दूसरा बाज़ार चुनें या ग्लोबल फ़्लो पर स्विच करें।",
            noOutgoingTitle: "{country} से अभी तक कोई आउटगोइंग सिग्नल नहीं",
            noOutgoingBody: "हमें मौजूदा डेटा में {country} से बाहर विस्तार करने वाली कोई कंपनी नहीं मिली है। इसके बजाय इस देश में विस्तार कर रहे लोगों को देखने के लिए चयनित बाज़ार दृश्य पर स्विच करने का प्रयास करें।",
            noOutgoingCta: "इस बाज़ार में विस्तार कर रही कंपनियाँ देखें",
            companiesCount: "{n} कंपनी | {n} कंपनियाँ",
            newThisMonthCount: "{n} इस महीने नए",
            clickHint: "विवरण के लिए बाज़ार पर होवर करें · ड्रिल-इन करने के लिए क्लिक करें",
            zoomIn: "ज़ूम इन",
            zoomOut: "ज़ूम आउट",
            resetView: "दृश्य रीसेट करें",
            densityShowN: "अधिकतम {n} बाज़ार | अधिकतम {n} बाज़ार",
            densitySliderAriaLabel: "मानचित्र घनत्व — अधिक या कम मूल दिखाने के लिए स्लाइड करें",
            legendAriaLabel: "मानचित्र किंवदंती",
            legendTitle: "चरण",
            legendSectionRecent: "हाल की गतिविधि",
            legendStageUp: "आगे बढ़ रहा है",
            legendStageUpTitle: "सायन रिंग उन देशों को चिह्नित करती है जो पिछले 30 दिनों में एक चरण आगे बढ़े हैं",
            legendNew: "नया",
            legendNewTitle: "चमकता हुआ बिंदु उन देशों को चिह्नित करता है जहाँ पिछले 90 दिनों में विस्तार शुरू हुआ",
            legendBadge30d: "30 दिन",
            legendBadge90d: "90 दिन",
            legendCollapse: "लीजेंड छोटा करें",
            legendExpand: "लीजेंड दिखाएँ",
            companies: "कंपनियाँ",
            // TODO: translate (placeholders copied from en.js)
            activityFeedEmptyGlobal: "Pick a market above to see companies that just moved stages.",
        },
        tooltip: {
            signals: "सिग्नल",
            companiesMoving: "आगे बढ़ रही कंपनियाँ",
            companiesExpandingFrom: "यहाँ से विस्तार कर रही कंपनियाँ",
            companiesArrivingAt: "इस मूल से आ रही कंपनियाँ",
            clickToScope: "सूची फ़िल्टर करने के लिए क्लिक करें →",
        },
        popover: {
            close: "बंद करें",
            loading: "विवरण लोड हो रहा है…",
            loadFailed: "यह बाज़ार लोड नहीं हो सका।",
            keyMoments: "मुख्य क्षण",
            signals: "सिग्नल ({n})",
            firstSignal: "पहला सिग्नल",
            latestSignal: "नवीनतम सिग्नल",
            reachedStage: "{stage} तक पहुँचा",
            stageUp: "चरण उन्नयन",
        },
        drawer: {
            title: "कंपनी विस्तार प्रोफ़ाइल",
            currentStage: "वर्तमान चरण",
            confidence: "विश्वास",
            confidenceHigh: "उच्च",
            confidenceMedium: "मध्यम",
            confidenceLow: "निम्न",
            signalGeneric: "सिग्नल",
            allSignals: "सिग्नल टाइमलाइन",
            signalsCount: "{n} सिग्नल",
            noSignals: "इस बाज़ार जोड़ी के लिए अभी तक कोई विस्तृत सिग्नल कैप्चर नहीं किए गए हैं।",
            contractionBanner: "सिकुड़न के सिग्नल मिले — संपर्क करने से पहले सत्यापित करें कि यह कंपनी अभी भी विस्तार कर रही है।",
            openFullProfile: "पूरी प्रोफ़ाइल खोलें",
            visitWebsite: "वेबसाइट देखें",
            // Expansion context (route between hero card and stage strip)
            expandingInto: "इसमें विस्तार कर रहा है",
            expandingFrom: "से",
            expansionTo: "तक विस्तार",
            signalsInMarket: "में सिग्नल",
            // Company overview tile
            companyAtAGlance: "कंपनी एक नज़र में",
            industry: "उद्योग",
            founded: "स्थापना",
            employees: "कर्मचारी",
            headquarters: "मुख्यालय",
            website: "वेबसाइट",
            // Presence section
            onTheGround: "ज़मीन पर",
            presenceOffice: "कार्यालय",
            presenceLegal: "कानूनी इकाई",
            presenceHiring: "भर्ती",
            // TODO: translate
            milestoneActiveRoles: "Reached {n} active role | Reached {n} active roles",
            milestoneScale: "Reached open-roles threshold",
            // Other markets
            alsoExpandingTo: "इसमें भी विस्तार कर रहा है",
            noOtherMarkets: "अभी तक कोई अन्य बाज़ार नहीं मिले।",
            showAll: "सभी दिखाएं ({n})",
            showLess: "कम दिखाएं",
            filterAll: "सभी",
            // Pace
            paceLabel: "विस्तार की गति",
            paceText: "पहले सिग्नल से {stage} तक {days} दिन",
            paceFast: "तेज़",
            paceTypical: "सामान्य",
            paceSlow: "धीमा",
            localTeamLabel: "स्थानीय टीम",
            lastActiveLabel: "पिछली गतिविधि",
            teamPeople: "लोग",
            localTeamNone: "कोई नहीं",
            localTeamNetNew: "नया बाज़ार",
            localTeamEmerging: "शुरुआती उपस्थिति",
            localTeamEstablished: "पहले से मौजूद",
            localTeamNoData: "—",
            localTeamNoDataMeta: "कोई स्थानीय डेटा नहीं",
            localTeamOnSite: "मौजूद",
            readScalingTitle: "मौजूदा टीम का विस्तार",
            readScalingDetail: "{market} में पहले से मौजूद — हालिया भर्ती और विज्ञापन नई एंट्री नहीं, बल्कि मौजूदा स्थानीय परिचालन का विस्तार हैं।",
            readDeepeningTitle: "उपस्थिति को गहरा करना",
            readDeepeningDetail: "{market} में स्थापित और सक्रिय रूप से विस्तार कर रहे हैं — यह पहली एंट्री नहीं, मौजूदा परिचालन का विस्तार है।",
            readSteadyTitle: "स्थानीय रूप से सक्रिय",
            readSteadyDetail: "{market} में स्थापित, स्थिर और निरंतर स्थानीय गतिविधि के साथ।",
            readEstablishingTitle: "उपस्थिति बना रहे हैं",
            readEstablishingDetail: "{market} में पहले से एक छोटी टीम है — हालिया संकेत इसे बढ़ाने की ओर इशारा करते हैं।",
            paceInMarket: "स्थानीय रूप से मौजूद",
            thisMarket: "इस बाज़ार",
            readAxesFootnote: "स्टेज हाल की गतिविधि दिखाता है · टीम आकार दिखाती है — दोनों अलग हो सकते हैं।",
            teamFoundDetail: "{market} में {n} लोग मिले — वास्तव में इससे अधिक हो सकते हैं।",
            // Signal labels
            signalSource: "{source} के माध्यम से",
            signalTierHint: "मुश्किल से मिलने वाली इंटेलिजेंस, Pubrio द्वारा प्रस्तुत",
            signalSourceFrom: "{source} के माध्यम से · {host}",
            signalViewSource: "स्रोत देखें",
            signalNoEvidence: "कोई स्रोत लिंक उपलब्ध नहीं",
            // Footer note
            poweredBy: "अंतिम पता लगाया गया सिग्नल",
            // TODO: translate (placeholders copied from en.js)
            signalsCountOf: "{n} of {total} signals",
            loadMore: "Load more signals",
            switchMarket: "Switch market",
            durationDays: "{n}d",
            durationWeeks: "{n}w",
            durationMonths: "{n}mo",
            durationYears: "{n}y",
            reachedStageAt: "Reached {stage} {when}",
            transitionDuration: "{duration} in {prev}",
            signalGroupTitle: "{n} × {type}",
            signalGroupContext: "{items}",
            headcountScalingTitle: "{n} jobs currently open",
            recentSignalsChip: "{n} {type} · 12w",
            activityLabel: "Activity",
            activityWindow: "{weeks} weeks",
            activityTotal: "All",
            activityFilterByType: "Filter timeline to {type}",
            activityCellTooltip: "{n} × {type} · {week}",
            activityCellMore: "+{n} more",
            activityCellEmpty: "No {type} signals · {week}",
            activityEmpty: "Quiet for now",
            activityEmptyHint: "No signals detected in the last 12 weeks — this company's expansion engine is paused or pre-launch.",
            snapshotLabel: "Current snapshot",
            showItems: "Show {n}",
            showItemsOf: "Show {n} of {total}",
            hideItems: "Hide",
            loadingMore: "Loading…",
        },
        live: {
            title: "बाज़ार अपडेट",
            live: "लाइव",
            all: "सभी",
            advancing: "आगे बढ़ रहा है",
            retreating: "पीछे हट रहा है",
            tabNews: "समाचार",
            tabFunding: "फंडिंग अंतर्दृष्टि",
            tabJobs: "नौकरी पोस्टिंग",
            tabAds: "विज्ञापन",
            sort: "क्रमबद्ध करें",
            sortNewest: "सबसे नए पहले",
            sortOldest: "सबसे पुराने पहले",
            sortImpact: "प्रभाव",
            filter: "फ़िल्टर",
            findPeople: "लोगों को खोजें",
            searchPlaceholder: "खोजें …",
            pendingBanner: "आपकी पिछली विज़िट के बाद से {n} नए लेख · लोड करने के लिए क्लिक करें",
            empty: "अभी तक कोई ट्रांज़िशन नहीं — जैसे ही कंपनियाँ आगे बढ़ेंगी, वे यहाँ दिखाई देंगी।",
            lastHour: "पिछला घंटा",
            advanced: "तक आगे बढ़ा",
            retreated: "से पीछे हटा",
            decayed: "से क्षीण हुआ",
            changed: "में परिवर्तित हुआ",
        },
        trending: {
            title: "ट्रेंडिंग कंपनियाँ",
            mostActiveToday: "आज सबसे सक्रिय",
            catAll: "सभी",
            catTechnology: "टेक्नोलॉजी",
            catFintech: "फिनटेक",
            catHealthcare: "हेल्थकेयर",
            catSaaS: "SaaS",
            more: "और",
            empty: "अभी तक कोई ट्रेंडिंग कंपनी नहीं।",
        },
        toast: {
            sequenceQueued: "सीक्वेंस में जोड़ें खुल गया — पॉपअप से एक सीक्वेंस चुनें।",
            savedToList: "{name} आपकी सूची में सहेजा गया।",
            saveFailed: "सूची में सहेजा नहीं जा सका। पुनः प्रयास करें।",
            exportReady: "{n} पंक्तियाँ एक्सपोर्ट कीं।",
            exportFailed: "एक्सपोर्ट विफल — एक छोटा बैच आज़माएं।",
        },
        export: {
            title: "विस्तार डेटा को CSV में एक्सपोर्ट करें",
            body: "{count} पंक्तियों को CSV में एक्सपोर्ट करने पर {price} क्रेडिट लगेंगे।",
        },
        watch: {
            cta: "इस व्यू को देखें",
            ctaShort: "देखें",
            watching: "देखा जा रहा है",
            newCount: "{n} नए",
            cadenceHeading: "मुझे सूचित करें",
            start: "देखना शुरू करें",
            recommended: "अनुशंसित",
            update: "मॉनिटर अपडेट करें",
            realtime: "रीयल-टाइम",
            realtimeDesc: "हर सिग्नल आने पर",
            daily: "दैनिक सारांश",
            dailyDesc: "हर दिन एक सारांश",
            weekly: "साप्ताहिक सारांश",
            weeklyDesc: "हर सोमवार एक सारांश",
            statusActive: "सक्रिय",
            statusPaused: "रोका गया",
            newMatches: "नए मिलान",
            lastChecked: "अंतिम जाँच",
            never: "अभी तक नहीं चला",
            frequency: "आवृत्ति",
            scope: "दायरा",
            scopeSummary: "{market} · {n} फ़िल्टर",
            allMarkets: "सभी बाज़ार",
            viewMatches: "मिलान देखें",
            pause: "रोकें",
            resume: "फिर शुरू करें",
            stop: "देखना बंद करें",
            namePlaceholder: "इस मॉनिटर को नाम दें",
            defaultName: "{market} · विस्तार सिग्नल",
            monitorName: "{market} · विस्तार सिग्नल #{date}",
            created: "देखा जा रहा है — नए सिग्नल की सूचना दी जाएगी",
            updated: "मॉनिटर अपडेट हुआ",
            stopped: "देखना बंद कर दिया",
            paused: "मॉनिटर रोका गया",
            resumed: "मॉनिटर फिर शुरू हुआ",
            viewChanged: "फ़िल्टर बदले गए — अपना मॉनिटर अपडेट करें",
            empty: "इस व्यू को देखने के लिए बाज़ार या फ़िल्टर जोड़ें",
        },
        widgetRail: {
            title: "अधिक विजेट",
            expandHint: "विस्तृत करने के लिए क्लिक करें",
        },
        errors: {
            loadFailed: "विस्तार डेटा लोड नहीं हो सका।",
            retry: "पुनः प्रयास करें",
        },
        time: {
            unknown: "—",
            today: "आज",
            daysAgo: "{n} दिन पहले",
            weeksAgo: "{n} सप्ताह पहले",
            monthsAgo: "{n} माह पहले",
            yearsAgo: "{n} वर्ष पहले",
        },
    },

};